import React from 'react'
import { CustomTitle } from 'src/components'
import { Withdrawal } from 'src/core/models'
import { getWithdrawalCompany } from 'src/core/helpers'

interface WithdrawalDateColumnProps { withdrawal: Withdrawal }

const WithdrawalCompanyColumn: React.FC<WithdrawalDateColumnProps> = ({ withdrawal }) => {
  const user = getWithdrawalCompany(withdrawal)

  return <div className='centered'>
    <CustomTitle label={user} />
  </div>
}

export default WithdrawalCompanyColumn
